module.exports = __webpack_public_path__ + "static/media/identity_icon1.png";